import React from 'react'
import Nav from '../Components/Outlets/Nav'
import why from '../Assets/why.svg'
import quran from '../Assets/quran.svg'
import Footer from '../Components/Outlets/Footer'

const Acadamics = () => {
	return (
		<div>
			<Nav />
			<div class="about-page-main">
				<div className="path-menus acadamics-page">
					<div className="container-main">
						<h2 class="page-heading-name mb-0">Acadamics</h2>
					</div>
				</div>
			</div>
			<div className="acadamics-page-box">
				<div className="container-main">
					<div className="row">
						<div className="col-lg-6">
							<div className="acadamics-inner">
								<h2 className="chairman-text">Why Eloria</h2>
								<p className="text-about-sub">Eloria International Girls School aims to facilitate a fertile ground for the overall growth of the next generation with their souls engraved in spiritual values and their skills ranging from coding to critical thinking chiselled to meet the unseen future of science and technology.</p>
								<p className="text-about-sub">We stand as the fulfilment of the dream of a skilled young generation who can contribute to national resources and boost moral development. This destination for incubating youth by fostering magnanimity in them will also take them to the summit of science and conscience.</p>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="acadamics-inner">
								<img src={why} className="acad-img" alt="" />
							</div>
						</div>
						<div className="col-lg-12">
							<div className="memmorisation-dv">
								<h2 className="chairman-text">Memorisation</h2>
								<img src={quran} className="quran-img" alt="" />
								<p className="text-about-sub">At Eloria, we believe in nurturing both the spiritual and intellectual dimensions of every student. Our memorisation programme combines traditional methods with psychologically informed pedagogy, boosting retention skills while cultivating analytical vigour — preparing each girl to carry knowledge with depth and purpose.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}

export default Acadamics
